var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c("gg-card-header", [_vm._v(" Add Redirect ")]),
              _c(
                "gg-card-text",
                [
                  _c("add-redirect-form", {
                    on: {
                      "redirect-added": _vm.loadRedirects
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c(
                "gg-card-header",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12",
                            md: "6"
                          }
                        },
                        [_vm._v(" Manage Redirects ")]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "font-weight-regular",
                          attrs: {
                            cols: "12",
                            md: "6"
                          }
                        },
                        [
                          _c("gg-text-field", {
                            attrs: {
                              "append-icon": "mdi-magnify",
                              placeholder: "Search",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.search,
                              callback: function callback($$v) {
                                _vm.search = $$v
                              },
                              expression: "search"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "gg-card-text",
                [
                  _c("redirects-table", {
                    ref: "redirectsTable",
                    attrs: {
                      search: _vm.search
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }